import React, { useEffect } from 'react';
import { clearFirestoreCache, resetFirebaseConnection } from '../../firebase';

/**
 * Component that listens for global errors and handles Firestore-specific ones
 * This component doesn't render anything, it just adds error handling
 */
const FirestoreErrorHandler = () => {
  useEffect(() => {
    // Function to handle unhandled errors
    const handleUnhandledError = async (event) => {
      const error = event.error || event.reason;
      if (!error) return;
      
      const errorMessage = error.message || String(error);
      console.error('Unhandled error caught by global handler:', error);
      
      // Check for Firestore internal assertion errors
      if (
        errorMessage.includes('FIRESTORE') && 
        (errorMessage.includes('INTERNAL ASSERTION FAILED') || 
         errorMessage.includes('Unexpected state') ||
         errorMessage.includes('ID: b815') || 
         errorMessage.includes('ID: ca9'))
      ) {
        console.warn('Detected Firestore internal assertion error. Attempting recovery...');
        event.preventDefault(); // Prevent default error handling
        
        try {
          // Try to clear cache first
          const clearResult = await clearFirestoreCache();
          
          if (clearResult.success) {
            console.log('Successfully cleared Firestore cache after global error');
            window.location.reload(); // Auto-reload the page to reset all states
            return;
          } 
          
          // If clearing cache failed, try connection reset
          console.log('Cache clearing failed, attempting connection reset...');
          const resetResult = await resetFirebaseConnection();
          
          if (resetResult.success) {
            console.log('Successfully reset Firestore connection after global error');
            window.location.reload(); // Auto-reload the page to reset all states
          } else {
            console.error('Failed to recover from Firestore error');
            // Last resort - reload anyway
            setTimeout(() => window.location.reload(), 1000);
          }
        } catch (handlerError) {
          console.error('Error in error handler:', handlerError);
          // Last resort - reload anyway
          setTimeout(() => window.location.reload(), 1000);
        }
      }
    };
    
    // Add global error listeners
    window.addEventListener('error', handleUnhandledError);
    window.addEventListener('unhandledrejection', handleUnhandledError);
    
    // Clean up listeners on unmount
    return () => {
      window.removeEventListener('error', handleUnhandledError);
      window.removeEventListener('unhandledrejection', handleUnhandledError);
    };
  }, []);
  
  // This component doesn't render anything
  return null;
};

export default FirestoreErrorHandler;
